import { containerPreviewCompact } from './cssPreviewContainer.js';
import { css } from 'styled-components';
import { RESOURCE_GRID_PREVIEW_CONTENT } from '@fabric-app/ui/theme/resourcePreviewConstants';
import { cssHoverBase } from '@fabric-app/ui/theme/sharedCss';

const cssPreviewShadow = css([
  `box-shadow:0px 4px 6px rgba(0,0,0,0.02),0px 0px 2px rgba(0,0,0,0.05);`
]);
const cssAspectRatio = css([
  `aspect-ratio:`,
  ` / `,
  `;`,
  `{aspect-ratio:initial;}`
], RESOURCE_GRID_PREVIEW_CONTENT.width, RESOURCE_GRID_PREVIEW_CONTENT.height, containerPreviewCompact);
const cssHover = css([
  ``,
  ` &:hover{`,
  `{[data-preview-content-wrapper='storef_file_thumbnail']{opacity:0.8;}}}`
], cssHoverBase, containerPreviewCompact);

export { cssAspectRatio, cssHover, cssPreviewShadow };
//# sourceMappingURL=sharedCss.js.map
